type UnitGroup = {
  unit: string;
  factor: number;
};

type AutoUnitGroups = Record<string, UnitGroup[]>;

type UnitConversion = {
  factor: number;
  unit: string;
};

type UnitConversions = Record<string, UnitConversion>;

interface FormatOptions {
  convert?: keyof UnitConversions;
  autoConvert?: boolean;
}

const autoUnitGroups: AutoUnitGroups = {
  m: [
    { unit: 'mm', factor: 1000 },
    { unit: 'cm', factor: 100 },
    { unit: 'm', factor: 1 },
    { unit: 'km', factor: 1 / 1000 },
    { unit: 'Mm', factor: 1 / 1_000_000 },
  ],
  s: [
    { unit: 'ms', factor: 1000 },
    { unit: 's', factor: 1 },
    { unit: 'min', factor: 1 / 60 },
    { unit: 'hr', factor: 1 / 3600 },
    { unit: 'd', factor: 1 / 86400 },
  ],
};

const unitConversions: UnitConversions = {
  'm-to-km': { factor: 1 / 1000, unit: 'km' },
  's-to-min': { factor: 1 / 60, unit: 'min' },
  'min-to-hr': { factor: 1 / 60, unit: 'hr' },
  'hr-to-d': { factor: 1 / 24, unit: 'd' },
};

export function formatNumber(
  value: number | string,
  unit: string = '',
  options: FormatOptions = {}
): string {
  const num = Number(value);
  if (isNaN(num)) return `${unit ? ' ' + unit : ''}`;

  let convertedValue = num;
  let finalUnit = unit;

  // Manual conversion
  if (options.convert && unitConversions[options.convert]) {
    const { factor, unit: targetUnit } = unitConversions[options.convert];
    convertedValue = num * factor;
    finalUnit = targetUnit;
  }
  // Auto conversion
  else if (options.autoConvert && autoUnitGroups[unit]) {
    const group = autoUnitGroups[unit];
    for (let i = group.length - 1; i >= 0; i--) {
      const { unit: u, factor } = group[i];
      const converted = num * factor;
      if (converted >= 1) {
        convertedValue = converted;
        finalUnit = u;
        break;
      }
    }
  }

  let formatted = convertedValue.toFixed(2).replace(/\.?0+$/, '');
  formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return finalUnit ? `${formatted} ${finalUnit}` : formatted;
}
